import { PortableTextBlock } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';

import { ISanityImage } from 'typescriptDefs';

interface Props {
  data: {
    heading: PortableTextBlock | PortableTextBlock[];
    image: ISanityImage;
    imageAltText: string;
    subheading: string;
  };
}

const Hero = ({ data }: Props) => {
  return (
    <Section className="px-32 pb-64 pt-40 md:px-[unset] md:pb-96 md:pt-64">
      <Container className="grid gap-64 md:grid-cols-2 md:gap-32">
        <div className="grid content-center">
          <div className="mb-16 md:mb-24 [&_h1]:w-[90%] [&_h1]:text-36 [&_h1]:text-primary-350 md:[&_h1]:w-[88%] md:[&_h1]:text-60 [&_h1_strong]:text-primary-200">
            <CustomPortableText content={data.heading} />
          </div>
          <p className="text-18 md:w-[80%] md:text-20">{data.subheading}</p>
        </div>
        <div className="max-h-640 overflow-hidden rounded-16">
          <GatsbyImage alt={data.imageAltText} image={data.image.asset.gatsbyImageData} />
        </div>
      </Container>
    </Section>
  );
};

export default Hero;
